(()=>{
 const input=document.querySelector('#faq-search');
 if(!input)return;
 const rows=[...document.querySelectorAll('.faq-questions details')];
 const groups=[...document.querySelectorAll('.faq-group')];
 const norm=s=>s.toLowerCase().replace(/ä/g,'a').replace(/ö/g,'o').replace(/ü/g,'u').replace(/ß/g,'ss').replace(/ae/g,'a').replace(/oe/g,'o').replace(/ue/g,'u').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
 const indexes=new Map(rows.map(row=>[row,norm(row.textContent+' '+row.dataset.keywords+' '+row.closest('.faq-group').querySelector('h2').textContent)]));
 const answers=new Map(rows.map(row=>{const answer=row.querySelector('.faq-answer');return [row,{element:answer,html:answer.innerHTML}];}));
 function highlight(row,terms){
  const answer=answers.get(row);
  answer.element.innerHTML=answer.html;
  if(!terms.length||row.hidden)return;
  const walker=document.createTreeWalker(answer.element,NodeFilter.SHOW_TEXT);
  const nodes=[];
  while(walker.nextNode())nodes.push(walker.currentNode);
  nodes.forEach(node=>{
   const text=node.nodeValue;
   let normalized='';const starts=[],ends=[];
   // Keep original character positions when umlauts or sharp s normalize.
   for(const part of text.matchAll(/ae|oe|ue|[\s\S]/gi)){
    const value=norm(part[0]);
    for(let i=0;i<value.length;i++){starts.push(part.index);ends.push(part.index+part[0].length);}
    normalized+=value;
   }
   const ranges=[];
   terms.forEach(term=>{let from=0,at;while((at=normalized.indexOf(term,from))!==-1){ranges.push([starts[at],ends[at+term.length-1]]);from=at+term.length;}});
   if(!ranges.length)return;
   ranges.sort((a,b)=>a[0]-b[0]);const merged=[];
   ranges.forEach(range=>{const last=merged[merged.length-1];if(last&&range[0]<=last[1])last[1]=Math.max(last[1],range[1]);else merged.push(range.slice());});
   const fragment=document.createDocumentFragment();let cursor=0;
   merged.forEach(([start,end])=>{fragment.append(document.createTextNode(text.slice(cursor,start)));const mark=document.createElement('mark');mark.className='faq-search-match';mark.textContent=text.slice(start,end);fragment.append(mark);cursor=end;});
   fragment.append(document.createTextNode(text.slice(cursor)));node.replaceWith(fragment);
  });
 }
 const reset=document.querySelector('#faq-reset');
 let previousOpen=null;
 function filter(){
  const terms=norm(input.value.trim()).split(/\s+/).filter(Boolean);
  input.closest('.faq-page')?.classList.toggle('is-searching',terms.length>0);
  if(terms.length&&!previousOpen)previousOpen=new Set(rows.filter(r=>r.open));
  let count=0;
  rows.forEach(row=>{const match=terms.every(term=>indexes.get(row).includes(term));row.hidden=!match;if(match)count++;if(terms.length)row.open=match;else if(previousOpen)row.open=previousOpen.has(row);});
  rows.forEach(row=>highlight(row,terms));
  if(!terms.length)previousOpen=null;
  groups.forEach(group=>group.hidden=![...group.querySelectorAll('details')].some(row=>!row.hidden));
  reset.hidden=!terms.length;
  document.querySelector('#faq-empty').hidden=count!==0;
  document.querySelector('#faq-status').textContent=terms.length?`${count} ${count===1?'passende Antwort':'passende Antworten'}`:'';
 }
 function clear(){input.value='';filter();}
 input.addEventListener('input',filter);
 input.form.addEventListener('submit',event=>{event.preventDefault();filter();document.querySelector('#faq-status').scrollIntoView({block:'center'});});
 reset.addEventListener('click',()=>{clear();input.focus();});
 document.querySelector('#faq-show-all').addEventListener('click',()=>{clear();input.focus();});
 function revealHash(){const target=document.getElementById(decodeURIComponent(location.hash.slice(1)));if(!target)return;if(target.matches('.faq-group,.faq-questions details')){if(input.value)clear();if(target.tagName==='DETAILS')target.open=true;requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));}}
 document.querySelectorAll('.faq-topics a,.faq-shortcuts a').forEach(a=>a.addEventListener('click',()=>{clear();if(location.hash===new URL(a.href).hash)revealHash();}));
 window.addEventListener('hashchange',revealHash);revealHash();
})();
